import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowRight, BarChart3, Users, GitBranch, ShieldCheck } from "lucide-react";

export default function Landing() {
    return (
        <div className="min-h-screen bg-white">
            <header className="px-6 lg:px-10 py-5 flex items-center justify-between border-b border-slate-100">
                <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded bg-orange-500 flex items-center justify-center text-white font-bold font-display">E</div>
                    <span className="font-display font-semibold text-slate-900 text-lg">Emprenovus</span>
                </div>
                <nav className="hidden md:flex items-center gap-8 text-sm text-slate-600">
                    <a href="#features" className="hover:text-slate-900">Funciones</a>
                    <a href="#why" className="hover:text-slate-900">Por qué</a>
                </nav>
                <div className="flex items-center gap-3">
                    <Link to="/login" className="text-sm text-slate-600 hover:text-slate-900" data-testid="nav-login">Iniciar sesión</Link>
                    <Button asChild data-testid="nav-register">
                        <Link to="/register">Probar gratis</Link>
                    </Button>
                </div>
            </header>

            <section className="px-6 lg:px-10 pt-16 pb-20 max-w-7xl mx-auto">
                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    <div className="space-y-6">
                        <span className="inline-flex items-center text-xs font-medium text-orange-700 bg-orange-50 px-3 py-1 rounded-full">CRM para equipos comerciales</span>
                        <h1 className="font-display text-5xl lg:text-6xl font-bold tracking-tight text-slate-900">
                            Convierte cada contacto en una <span className="text-orange-600">oportunidad real</span>
                        </h1>
                        <p className="text-lg text-slate-600 max-w-xl">
                            Emprenovus CRM centraliza prospectos, empresas, embudos y tareas. Diseñado para equipos que necesitan claridad, control y velocidad sin complicaciones.
                        </p>
                        <div className="flex flex-wrap items-center gap-3">
                            <Button asChild size="lg" data-testid="hero-cta">
                                <Link to="/register">Empezar ahora <ArrowRight className="w-4 h-4 ml-2" /></Link>
                            </Button>
                            <Button asChild variant="outline" size="lg">
                                <Link to="/login">Ver demo</Link>
                            </Button>
                        </div>
                    </div>
                    <div className="relative">
                        <img
                            src="https://images.pexels.com/photos/577210/pexels-photo-577210.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                            alt="CRM en uso"
                            className="rounded-xl border border-slate-200 shadow-2xl shadow-slate-900/10"
                        />
                    </div>
                </div>
            </section>

            <section id="features" className="px-6 lg:px-10 py-16 bg-slate-50">
                <div className="max-w-7xl mx-auto">
                    <h2 className="font-display text-3xl font-semibold tracking-tight text-slate-900 mb-10">Todo lo que tu equipo necesita</h2>
                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {[
                            { icon: Users, title: "Prospectos y contactos", desc: "Importa desde Excel y CSV. Asocia contactos a empresas." },
                            { icon: GitBranch, title: "Embudos editables", desc: "Crea múltiples funnels con etapas personalizables." },
                            { icon: BarChart3, title: "Métricas en vivo", desc: "Conversión, pipeline, actividad y carga comercial." },
                            { icon: ShieldCheck, title: "Roles y permisos", desc: "Superadmin, vendedor y soporte. Control total." },
                        ].map((f, i) => (
                            <div key={i} className="bg-white border border-slate-200 rounded-lg p-6">
                                <div className="w-10 h-10 rounded bg-orange-50 text-orange-600 flex items-center justify-center mb-4">
                                    <f.icon className="w-5 h-5" />
                                </div>
                                <h3 className="font-display font-semibold text-slate-900 mb-1">{f.title}</h3>
                                <p className="text-sm text-slate-600">{f.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <footer className="px-6 lg:px-10 py-8 border-t border-slate-100 text-sm text-slate-500 flex items-center justify-between">
                <span>© {new Date().getFullYear()} Emprenovus</span>
                <span>Construido para equipos modernos</span>
            </footer>
        </div>
    );
}
